module.exports = __webpack_public_path__ + "static/img/03.5fea937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/Ukrzaliznytsia/03.jpg
// module id = nzbc
// module chunks = 7